// extracted by mini-css-extract-plugin
export default {"chartContainer":"SocialMessageAnalysis_chartContainer__03CAk","total":"SocialMessageAnalysis_total__9-RTt"};